import { createApp } from 'vue';
import App from './App.vue';
import routerDesktop from './router';
import routerMobile from './mobile/router';
import store from './store';
import Quasar from 'quasar/src/vue-plugin.js';import Platform from 'quasar/src/plugins/platform/Platform.js';;
import quasarUserOptions from './quasar-user-options';
import vue3JsonExcel from 'vue3-json-excel';

const mode = window.localStorage.getItem('view-mode');

if (Platform.is.mobile && !mode) {
  window.localStorage.setItem('view-mode', 'mobile');
}

const app = createApp(App);
Platform.is.mobile && window.localStorage.getItem('view-mode') === 'mobile'
  ? app.use(routerMobile)
  : app.use(routerDesktop);
app.directive('scroll', scroll);
app.use(vue3JsonExcel);
app.use(Quasar, quasarUserOptions);
app.use(store);
app.mount('#app');
